import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@figure/frontlib-gui';
import { isProd } from 'shared/utils';

const ESCAPE = 'Escape';

const CspButton = ({ identityUuid, plUuid }) => {
  const [showButton, setShowButton] = useState(false);

  const handleKeyDown = (event) => event.key === ESCAPE && setShowButton(true);
  const handleKeyUp = (event) => event.key === ESCAPE && setShowButton(false);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
    };
  });

  const handleClick = () => window.open(`https://test.figure.com/csp/profile/${identityUuid}/application/pl/${plUuid}`);

  if (isProd()) return null;

  return showButton && <Button onClick={handleClick}>Open in CSP</Button>;
};

CspButton.propTypes = {
  identityUuid: PropTypes.string,
  plUuid: PropTypes.string,
};

CspButton.defaultProps = {
  identityUuid: '',
  plUuid: '',
};

export default CspButton;
